import { trackPendoEvent } from "@/utils/pendo";

export const AI_ASSISTANT_PENDO_EVENTS = {
  OPENED: "Lou-Opened",
  CLOSED: "Lou-Closed",
  NEW_CHAT_CLICKED: "Lou-New-Conversation-Clicked",
  NEW_CHAT_STARTED: "Lou-New-Conversation-Started",
  NEW_CHAT_FAILED: "Lou-New-Conversation-Failed",
  QUESTION_SUBMITTED: "Lou-Question-Submitted",
  RESPONSE_COMPLETED: "Lou-Response-Completed",
  RESPONSE_FAILED: "Lou-Response-Failed",
  SCREEN_SUMMARY_REQUESTED: "Lou-Screen-Summary-Requested",
  FEEDBACK_SUBMITTED: "Lou-Feedback-Submitted",
  COPY_CLICKED: "Lou-Message-Copied",
  LINK_OPENED: "Lou-Link-Opened",
  LINK_COPIED: "Lou-Link-Copied",
  TOOL_TOGGLED: "Lou-Tool-Toggled",
  FOLLOWUP_CLICKED: "Lou-Follow-Up-Clicked",
  DOWNLOAD_CLICKED: "Lou-Download-Clicked",
};

const getCurrentPage = () => {
  if (typeof window === "undefined") return "";
  return window.location.pathname;
};

export const trackAssistantEvent = (eventName, metadata = {}) => {
  trackPendoEvent(eventName, {
    productArea: "HQB - AI (Lou)",
    page: getCurrentPage(),
    timestamp: new Date().toISOString(),
    ...metadata,
  });
};
